// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1ncNl","row":"Node_row__w8R2o","label":"Node_label__2GImz","footer":"Node_footer__mahPN"};